export class StringHelper {
    static pad(num: number, size: number): string {
        let s = num + '';
        while (s.length < size) {
            s = '0' + s;
        }
        return s;
    }

    public static htmlDecode(value: string): string {
        const textArea = document.createElement('textarea');
        textArea.innerHTML = value;
        return textArea.value;
    }

    public static htmlEncode(value: string): string {
        const textArea = document.createElement('textarea');
        textArea.innerText = value;
        return textArea.innerHTML.split('<br>').join('\n');
    }
}
